/**
 * 用于防止获取对象的深层属性时报错
 * @param getFn: 返回取值的函数
 * @param expectVal: 期望的默认值
 * @returns
 */

export default (getFn, expectVal?) => {
  try {
    return getFn()
  } catch (e) {
    return expectVal || null
  }
}
